import {
  GetSectionPostOptionsProps,
  PostOption,
  SectionPostOptions,
} from '../../../helpers/types'

/* getCarouselAppAdModule takes a post component's post options and converts them to a dynamic module Component */
export const getCarouselAppAdModule = ({
  module,
}: GetSectionPostOptionsProps): SectionPostOptions => {
  let ctaUrl = module?.igCarouselAppAdWebsiteUrlOption
  if (typeof ctaUrl === 'object')
    ctaUrl = (module?.igCarouselAppAdWebsiteUrlOption as PostOption)?.content
  if (!ctaUrl) ctaUrl = ''

  return {
    ctaUrl: ctaUrl,
    headline: module?.igCarouselAppAdHeadline || '',
  }
}
